import { render, staticRenderFns } from "./handmadePrescriptionConfirm.vue?vue&type=template&id=18d0f733&scoped=true"
import script from "./handmadePrescriptionConfirm.vue?vue&type=script&lang=js"
export * from "./handmadePrescriptionConfirm.vue?vue&type=script&lang=js"
import style0 from "./handmadePrescriptionConfirm.vue?vue&type=style&index=0&id=18d0f733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0f733",
  null
  
)

export default component.exports